import { render, staticRenderFns } from "./activity-file-item.component.vue?vue&type=template&id=18c6fbb0&scoped=true&"
import script from "./activity-file-item.component.vue?vue&type=script&lang=ts&"
export * from "./activity-file-item.component.vue?vue&type=script&lang=ts&"
import style0 from "./activity-file-item.component.vue?vue&type=style&index=0&id=18c6fbb0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c6fbb0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
